import React from 'react';
import { GVTypography } from 'components/lib';
import { Box, Theme } from '@mui/material';
import { menuLightGrey } from 'styles/vars';
import GVTooltip from 'components/lib/GVToolTip/GVTooltip';
import { makeStyles } from 'tss-react/mui';

export interface DifferenceGridElementProps {
  difference?: boolean;
  character: string;
  tooltipContainer: HTMLElement | null;
}

const useStyles = makeStyles()((theme: Theme) => ({
  root: {
    height: '25px',
    maxHeight: '25px',
    width: '18px',
    maxWidth: '18px',
    borderRadius: '4px',
    display: 'inline-flex',
    justifyContent: 'center',
    verticalAlign: 'middle',
    margin: '1px',
    float: 'left',
    position: 'relative',
    cursor: 'default',
    '&:hover': {
      zIndex: 2000,
    },
  },
  difference: {
    backgroundColor: theme.palette.error.main,
  },
  noDifference: {
    backgroundColor: menuLightGrey,
  },
  character: {
    alignSelf: 'center',
  },
}));

const DifferenceGridElement = React.forwardRef<HTMLDivElement, DifferenceGridElementProps>(
  ({ difference = false, character, tooltipContainer }, ref) => {
    const { classes, cx } = useStyles();

    const getUnicodeFromChar = (char: string) => {
      // don't show tooltip for padding character (i.e., \u0001)
      if (!char || char.charCodeAt(0) === 1) return '';

      const code = char.charCodeAt(0);
      let hex = code.toString(16).toUpperCase();
      while (hex.length < 4) {
        hex = `0${hex}`;
      }
      return `Unicode: U+${hex}`;
    };

    return (
      <GVTooltip title={getUnicodeFromChar(character)} side="top" arrow container={tooltipContainer}>
        <Box
          ref={ref}
          className={cx(classes.root, difference ? [classes.difference, 'difference'] : classes.noDifference)}
        >
          <GVTypography variant="body1" color="primary" className={classes.character}>
            {character}
          </GVTypography>
        </Box>
      </GVTooltip>
    );
  },
);
DifferenceGridElement.displayName = 'DifferenceGridElement';

export default DifferenceGridElement;
